// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"717": "fecdbb8c2ec5e4f5","994": "1dc8d460ce21e34f",}[chunkId] + ".css"
}